import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid, List as ListIcon } from 'lucide-react';
import { NaatKhawan } from '../types';
import { naatKhawanService } from '../services/api';
import SEO from '../components/SEO';
import './NaatKhawansPage.css';

const NaatKhawansPage: React.FC = () => {
  const [naatKhawans, setNaatKhawans] = useState<NaatKhawan[]>([]);
  const [loading, setLoading] = useState(true);
  const [layout, setLayout] = useState<'grid' | 'list'>('grid');

  useEffect(() => {
    const fetchNaatKhawans = async () => {
      try {
        const response = await naatKhawanService.getAlphabetical();
        if (response.success) {
          setNaatKhawans(response.data);
        }
      } catch (error) {
        // Error fetching NaatKhawans
      } finally {
        setLoading(false);
      }
    };

    fetchNaatKhawans();
  }, []);

  const handleLayoutChange = (mode: 'grid' | 'list') => {
    setLayout(mode);
  };

  if (loading) {
    return (
      <div className="naatkhawans-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading Naat Khawans list...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="naatkhawans-page">
      <SEO
        title="Naat Khawans - NaatCity"
        description="Explore our comprehensive directory of renowned Naat Khawans. Discover Islamic reciters and their beautiful collections of Naats, Hamds, and spiritual recitations."
        keywords="naat khawans, islamic reciters, naat singers, qari list, famous naat khawans, urdu naat khawans"
        url="https://naatcity.com/naatkhawans"
      />
      <div className="page-header">
        <div className="header-content">
          <div className="header-center">
            <h1>Naat Khawans</h1>
            <div className="results-count">
              {naatKhawans.length} NaatKhawans
            </div>
          </div>
          <div className="layout-toggle" role="group" aria-label="Change layout">
            <button
              type="button"
              className={`layout-btn ${layout === 'grid' ? 'active' : ''}`}
              aria-pressed={layout === 'grid'}
              onClick={() => handleLayoutChange('grid')}
            >
              <LayoutGrid size={16} /> <span className="visually-hidden">Grid view</span>
            </button>
            <button
              type="button"
              className={`layout-btn ${layout === 'list' ? 'active' : ''}`}
              aria-pressed={layout === 'list'}
              onClick={() => handleLayoutChange('list')}
            >
              <ListIcon size={16} /> <span className="visually-hidden">List view</span>
            </button>
          </div>
        </div>
      </div>

      <div className={`naatkhawans-grid ${layout === 'list' ? 'list-mode' : ''}`}>
        {naatKhawans.map((naatKhawan) => {
            return (
              <Link
                key={naatKhawan.id}
                to={`/naatkhawan/${naatKhawan.id}`}
                className={`naatkhawan-card ${layout === 'list' ? 'list-card' : ''}`}
              >
                

                <div className="card-content with-bottom-bar">
                  <div className="card-body">
                    <h3 className="naatkhawan-name">{naatKhawan.name}</h3>
                  </div>
                  <div className="naatkhawan-card-bottom">
                    <span className="naatkhawan-count">{naatKhawan.audioCount || 0} Naats</span>
                    {naatKhawan.urduName && (
                      <span className="naatkhawan-urdu-name inline">{naatKhawan.urduName}</span>
                    )}
                  </div>
                </div>
              </Link>
            );
        })}
      </div>
    </div>
  );
};

export default NaatKhawansPage;